import { ChangeDetectionStrategy, Component, HostBinding, Input } from '@angular/core';

@Component({
  selector: 'x-banner-button',
  templateUrl: './banner-button.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    class: 'x-banner-button',
  },
})
export class BannerButtonComponent {
  @Input() label: string;
  @Input() tag: string | undefined | null;
  @Input() radioButton: boolean = false;

  @Input() iconPrefixAlignment: 'top' | 'bottom';
  @Input() iconSuffixAlignment: 'top' | 'bottom';

  @HostBinding('class.active')
  @Input()
  active: boolean | null | undefined = false;

  @Input() loading: boolean = false;
}
